export default __webpack_public_path__ + "static/media/image1.343a3975.jpg";